const state = {
    employees: [],
    employeeid: null,
    employeeDocs: [],
    employeeDocId: null,
    loading: false
};

export default state;